const CONTACT_PAGE_URLS = {
  en: "https://linkedscope.com/contact",
  pt: "https://linkedscope.com/pt/contato",
  es: "https://linkedscope.com/es/contacto",
};

const PLANS_PAGE_URLS = {
  en: "https://linkedscope.com/plans",
  pt: "https://linkedscope.com/pt/planos",
  es: "https://linkedscope.com/es/planes",
};

const TERMS_OF_USE_URLS = {
  en: "https://linkedscope.com/terms-of-use",
  pt: "https://linkedscope.com/pt/termos-de-uso",
  es: "https://linkedscope.com/es/terminos-de-uso",
};

const PRIVACY_POLICY_URLS = {
  en: "https://linkedscope.com/privacy-policy",
  pt: "https://linkedscope.com/pt/politica-de-privacidade",
  es: "https://linkedscope.com/es/politica-de-privacidad",
};

function resolveContactLanguage(language) {
  const normalizedLanguage = String(language || "").toLowerCase().trim();

  if (normalizedLanguage.startsWith("pt")) {
    return "pt";
  }
  if (normalizedLanguage.startsWith("es")) {
    return "es";
  }
  return "en";
}

export function buildPlansPageUrl(language) {
  return PLANS_PAGE_URLS[resolveContactLanguage(language)];
}

export function buildTermsOfUseUrl(language) {
  return TERMS_OF_USE_URLS[resolveContactLanguage(language)];
}

export function buildPrivacyPolicyUrl(language) {
  return PRIVACY_POLICY_URLS[resolveContactLanguage(language)];
}

export function buildContactPageUrl(language) {
  return CONTACT_PAGE_URLS[resolveContactLanguage(language)];
}

export function buildContactUrl(language, { name, email, company } = {}) {
  const params = new URLSearchParams({
    cname: String(name || "").trim(),
    email: String(email || "").trim(),
    company: String(company || "").trim(),
  });
  return `${CONTACT_PAGE_URLS[resolveContactLanguage(language)]}?${params.toString()}`;
}
